import { AnchorHTMLAttributes, PropsWithChildren, ReactNode } from "react";
import styles from "./LinkPill.module.css";
import { IntlLinkProps, Link } from '@/i18n/navigation'


type LinkPillProps = {
  href: string;
  children: ReactNode;
  internal?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement> &
  Partial<IntlLinkProps>;

export default function LinkPill({ internal, href, className, children,...props }: PropsWithChildren<LinkPillProps>) {
  const isInternal = internal ?? (typeof href === "string" && href.startsWith("/"))

  if (isInternal) {
    return (
      <Link href={href}
        className={`
        ${styles.main}
        ${className}
        `}
        {...props}
        data-testid="LinkPill"
        >
        {children}
      </Link>
    );
  }
  return (
      <a href={href}
        target='_blank'
        rel='noreferrer'
        className={`
        ${styles.main}
        ${className}
        `}
         {...props}>
        {children}
      </a>
  );
}
